import React from 'react';
import Layout from '../components/Layout/Layout';
import { getSeoData } from '../utils/helpers';
import { BookmarksPage } from '../components/Views/BookmarksPage';

const Bookmarks = () => <BookmarksPage />;

Bookmarks.getInitialProps = async ({ apolloClient, asPath, req }) => {
  const seoData = await getSeoData(apolloClient, asPath, req);

  return {
    seoData
  };
};

Bookmarks.getLayout = function getLayout(page) {
  return <Layout hideMobileHeader>{page}</Layout>;
};

export default Bookmarks;
